import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import LabeledToggle from '../../shared/LabeledToggle';

import SectionTitle from '../../shared/SectionTitle';
import SectionDescription from '../../shared/SectionDescription';

import styles from './styles.scss';

const GraphSettings = ({ includeAdditionlGraph, enableRadonAverage, onChange }) => [
  <Row key="content">
    <Col className={`py-3 px-0 mx-3 ${styles.infoSection}`}>
      <div className={styles.dataBlock}>
        <SectionTitle title="Graph Settings" />
        <SectionDescription description="Note: The graph below will only display if the device used on the test provides the data" />
      </div>
      <div className={styles.toggle}>
        <LabeledToggle
          label="Include additional sensor graphs on report"
          checked={includeAdditionlGraph}
          onChange={() => onChange('graphIncludeAdditionalSensor', !includeAdditionlGraph)}
        />
        <LabeledToggle
          label='Enable "Radon Average" line'
          checked={enableRadonAverage}
          onChange={() => onChange('graphRadonAverageLineEnabled', !enableRadonAverage)}
        />
      </div>
    </Col>
  </Row>,
];

GraphSettings.propTypes = {
  includeAdditionlGraph: PropTypes.bool,
  enableRadonAverage: PropTypes.bool,
  onChange: PropTypes.func,
};

export default GraphSettings;



// WEBPACK FOOTER //
// src/components/reportContentLayout/GraphSettings/index.jsx